import {deleteDoc} from 'firebase/firestore';
import getTodoDocRef from './getTodoDocRef';

export default async function deleteTodoDoc(uid: string, todoId: string): Promise<void> {
  await deleteDoc(getTodoDocRef(uid, todoId));
}
